import React, {Component} from 'react'
import ChangePasswordForm from './ChangePasswordForm'
import {Actions} from 'jumpstate'
import {browserHistory} from 'react-router'
import {Form} from 'react-form'
import {Row, Tabs, Tab} from 'react-bootstrap'
import showToastr from '../../../utils/showToastr'
import ErrorHandler from '../../../utils/ErrorHandler'
import validateChangePassword from '../../../utils/validateChangePassword'

export const defaultValues = {
  old_password: '',
  new_password: ''
}

class ChangePasswordScreen extends Component {
  constructor (props) {
    super(props)
    this.state = {
      currentValues: defaultValues,
      message: {status: '', context: ''},
      isLoading: false
    }
    this.submit = this.submit.bind(this)
  }

  submit (values) {
    this.setState({isLoading: true})
    Actions.changePassword(values).then((res) => {
      this.setState({isLoading: false})
      showToastr('success', 'تغییر رمز عبور', res.data.messages[0])
      browserHistory.push('/user/profile')
    }).catch((err) => {
      let eh = new ErrorHandler(err)
      this.setState({message: eh.message, isLoading: false})
      eh.setFormErrors(this.refs.changePasswordForm)
      eh.showToastrIn('تغییر رمز عبور')
    })
  }

  render () {
    const { currentValues, message, isLoading } = this.state
    return (
      <Row className="Box">
        <Tabs defaultActiveKey={1} id="uncontrolled-tab-example">
          <Tab eventKey={1} title="تغییر رمز عبور">
            <Form
              ref="changePasswordForm"
              validate={validateChangePassword}
              disable={isLoading}
              message={message}
              values={currentValues}
              onSubmit={this.submit}
              isLoading={isLoading}
            >
              {ChangePasswordForm}
            </Form>
          </Tab>
        </Tabs>
      </Row>
    )
  }
}

export default ChangePasswordScreen



// WEBPACK FOOTER //
// ./src/components/User/ChangePassword/ChangePasswordScreen.js